import { useEffect } from "react";
import Footer from "./Footer";
// import Header from "./Header";
// import EnterpriseHeader from "../../components/ui/enterprise1/EnterpriseHeader";
// import EnterpriseFooter from "../../components/ui/enterprise1/EnterpriseFooter";
import ZertoHeader from "./ZertoHeader";

const ZertoLayout = ({ children, title = "React App", variant }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <main className="relative">
      <ZertoHeader />
      {children}
      <Footer />
    </main>
  );
};

export default ZertoLayout;
